<template>
    <div class="loader" :style="'width: ' + width + ';height: ' + width + ';border: ' + thickness + ' solid #f3f3f3;border-top: ' + thickness + ' solid #3498db;'"></div>
</template>
<script>
    export default {
        props: [
            'width',
            'thickness'
        ]
    }
</script>
<style scoped>
    .loader {
        border-radius: 50%;
        width: 120px;
        height: 120px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }

    /* Safari */
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>


// WEBPACK FOOTER //
// src/components/Utils/Loader.vue